import * as Sentry from "@sentry/browser";
import React, { Component, ErrorInfo, PropsWithChildren } from "react";

import ErrorPage from "./components/global-furniture/ErrorPage";

type ErrorReportingProps = PropsWithChildren<unknown>;

export default class ErrorReporting extends Component<ErrorReportingProps, { eventId?: string; hasError: boolean }> {
  constructor(props: ErrorReportingProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, { componentStack }: ErrorInfo) {
    Sentry.captureException(error, { contexts: { react: { componentStack } } });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}
